import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import { Typography, Checkbox, FormControlLabel, Grid } from '@material-ui/core';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@material-ui/icons';
import moment from 'moment';

import { Button } from '@lc/legacy/src/Components';

const PeriodDaySelector = ({
  classes,
  setCheckedStatus,
  checkeds,
  current,
  period_hours,
  handleBack,
  handleNext,
  hideArrows,
  title,
}) => {
  const dateFormat = date => {
    const [, , day] = date.split('-');
    const month = moment()
      .locale('pt-br')
      .localeData()
      .months(moment(date));
    return `${day} de ${month.toLocaleLowerCase()}`;
  };

  const periodDuration = item => {
    const [hour, minute] = item.split(':');
    const toInt = parseInt(hour, 10) + period_hours;
    const time = `${toInt}:${minute}`;
    const moreFour = toInt < 10 ? `0${time}` : `${time}`;
    return `${item} - ${moreFour}`;
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Typography variant="body2" color="textPrimary">
        <b>{title}</b>
      </Typography>
      <Grid className={classes.container}>
        <Grid container direction="row" spacing={0} align="center" alignItems="center">
          <Grid item xs={1}>
            <Button className={classes.button}>
              {!hideArrows && <KeyboardArrowLeft onClick={handleBack} />}
            </Button>
          </Grid>
          <Grid item xs={10}>
            <Typography variant="body1" color="secondary" className={classes.label}>
              {dateFormat(current.name)}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Button className={classes.button}>
              {!hideArrows && <KeyboardArrowRight onClick={handleNext} />}
            </Button>
          </Grid>
        </Grid>
        {current.value.map(item => {
          const name = `${current.name}@${item}`;
          return (
            <div className={classes.itemTime} key={name}>
              <FormControlLabel
                style={{ marginLeft: 0, marginRight: 0, display: 'block' }}
                control={
                  <Checkbox
                    style={{ display: 'none' }}
                    checked={checkeds[name] || false}
                    onChange={setCheckedStatus}
                    name={name}
                    value={item}
                  />
                }
                label={
                  <Grid key={item} align="center" style={{ background: '#f1f1f1' }}>
                    <Grid item xs={1} />
                    <Grid item xs={10} className={classes.contentItem}>
                      <Typography
                        style={{ display: 'flex', alignItems: 'center' }}
                        variant="body1"
                        color={checkeds[name] ? 'secondary' : 'initial'}
                      >
                        {periodDuration(item)}
                      </Typography>
                    </Grid>
                    <Grid item xs={1} />
                  </Grid>
                }
              />
            </div>
          );
        })}
      </Grid>
    </>
  );
};

PeriodDaySelector.propTypes = {
  checkeds: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  current: PropTypes.object.isRequired,
  handleBack: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired,
  hideArrows: PropTypes.bool,
  setCheckedStatus: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  min_hours: PropTypes.number.isRequired,
  period_hours: PropTypes.number.isRequired,
  period_type: PropTypes.string.isRequired
};

PeriodDaySelector.defaultProps = {
  hideArrows: false,
};

const styles = theme => ({
  container: {
    borderRadius: '4px',
    border: '0.7px solid #797979',
    margin: '18px 0 0 0',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    background: '#fff',
    justifyContent: 'space-between',
    height: '55px',
  },
  button: {
    color: theme.palette.secondary.main,
    minWidth: 0,
    padding: 0,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '160px',
  },
  contentItem: {
    height: '50px',
    display: 'flex',
    justifyContent: 'center',
    marginTop: 5,
  },
  label: {
    fontWeight: 'bold',
  },
  itemTime: {},
});

export default withStyles(styles)(PeriodDaySelector);
